import type BaseEnumType from "@/app/services/baseEnumType";

import { EnumAssemblyType } from "@/app/services/generated/enums/enumAssemblyType.generated";
import Key from "@/app/types/common/key";
import type { Maybe } from "@/components/utils/typeHelpers";
import { keys, translate } from "@/plugins/i18n";

export class EnumOutputMovementType implements BaseEnumType {
  private static allValues: EnumOutputMovementType[] = [];

  public static moveToBatch = new EnumOutputMovementType(
    0,
    "Move to Batch",
    keys.assembly_move_to_batch.value,
    EnumAssemblyType.materialProduction
  );
  public static package = new EnumOutputMovementType(
    1,
    "Package",
    keys.assembly_package.value,
    EnumAssemblyType.productPackaging
  );
  public static moveToStock = new EnumOutputMovementType(
    2,
    "Move to Stock",
    keys.assembly_move_to_stock.value,
    undefined
  );

  public static scanAndFillTrackedContainers = new EnumOutputMovementType(
    3,
    "Scan and Fill Tracked Containers",
    keys.assembly_scan_fill_tracked_containers.value,
    undefined
  );

  public key: number;
  public value: string;
  public translationKey: string;
  public assemblyType: EnumAssemblyType | undefined;

  public get translation() {
    return translate(Key.fromString(this.translationKey));
  }

  private constructor(
    key: number,
    value: string,
    translationKey: string,
    assemblyType: EnumAssemblyType | undefined
  ) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    this.assemblyType = assemblyType;

    EnumOutputMovementType.allValues.push(this);
  }

  public equals(other: Maybe<EnumOutputMovementType>): boolean {
    return this.key === other?.key;
  }

  public isMoveToBatch() {
    return this.equals(EnumOutputMovementType.moveToBatch);
  }
  public isPackage() {
    return this.equals(EnumOutputMovementType.package);
  }
  public isMoveToStock() {
    return this.equals(EnumOutputMovementType.moveToStock);
  }
  public isScanAndFillTrackedContainers() {
    return this.equals(EnumOutputMovementType.scanAndFillTrackedContainers);
  }

  public static getValues(): EnumOutputMovementType[] {
    return EnumOutputMovementType.allValues;
  }

  public static getByKey(key: number): EnumOutputMovementType {
    const found = EnumOutputMovementType.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOutputMovementType - Key not found: ${key}`);
    }

    return found;
  }
}
